module.exports = __webpack_public_path__ + "img/632f1eba4a0d2f6efa68582a_1-p-1080.2527e391.png";